import { useEffect } from 'react';
import { useGoogleMapsContext } from '@/contexts/GoogleMapsContext';
import type { GoogleMapsAPIState } from '@/types/googleMaps';

export const useGoogleMapsAPI = (apiKey: string): GoogleMapsAPIState => {
  const { state, loadAPI } = useGoogleMapsContext();

  useEffect(() => {
    if (!state.isLoaded && !state.isLoading && apiKey) {
      loadAPI(apiKey).catch(() => {
        // Error is handled in context
      });
    }
  }, [apiKey, state.isLoaded, state.isLoading, loadAPI]);

  return state;
};
